module.exports = __webpack_public_path__ + "img/mobile/Menus-betmenu/btn-rules-selected@2x.png?1.0.17";